import React from 'react';
import Icon from '../../../../../icon';
import Button from '../../../../../button';
import {useDispatch} from 'react-redux';
import {isLabelSelectedOnMobile} from '../../../../../../../actions/mobileActions';
import './index.css'

function ReturnToLabelsButton () {

	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(isLabelSelectedOnMobile(false))
	};

	return (
		<Button onClick={handleClick} className="return-to-labels-button">
			<Icon name="long-arrow-left"/>
		</Button>
	)
}

export default ReturnToLabelsButton;
